import React from 'react';

interface TabsProps {
    tabs: {id: string; label: string}[];
    activeTab: string;
    setActiveTab: (id: string) => void;
    secondary?: boolean;
    ignore?: string[];
}

export default function TabsComponent(props: Readonly<TabsProps>): JSX.Element {
    const {tabs, activeTab, setActiveTab, secondary = false, ignore = []} = props;

    return (
        <nav className={`c-tabs ${secondary ? 'c-tabs--secondary' : ''}`}>
            {tabs.map((tab) => {
                if (ignore.includes(tab.id)) return null;

                return (
                    <button
                        key={tab.id + tab.label}
                        className={`c-tabs__tab ${activeTab === tab.id ? 'is-active' : ''} ${secondary ? 'c-tab--secondary' : ''}`}
                        type="button"
                        onClick={() => setActiveTab(tab.id)}
                        value={tab.id}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </nav>
    );
}
